<button *ngIf="!pending" [disabled]="disabled" (click)="PerformAction()" class="btn {{btnClass}}">
	<ng-content></ng-content>
</button>
<button *ngIf="pending" class="btn {{btnClass}}" [disabled]="true">{{processing}}</button>
<div *ngIf="problem" class="problem message-bad">{{problem}}</div>
<div *ngIf="success && complete" class="success message-good">{{complete}}</div>